/**
 * @module tree/remove
 */

/**
 * Removes an element from its parent
 * @param {Element|Text} target
 */
export default (
  target
) => {
  const { parentNode } = target

  parentNode?.removeChild(target)
}
